import { SbpPayment, SbpRefundOperation } from '../../types.ts'
import { Amount, DataRow, Date, OperationType, SbpPaymentStatus, Text } from '../../components'

export const MAIN_INFO_LABELS: Array<DataRow<SbpPayment>> = [
  { key: 'type', label: 'Тип операции', renderer: OperationType },
  { key: 'trxTime', label: 'Время оплаты', renderer: Date },
  { key: 'paymentPurpose', label: 'Назначение платежа', renderer: Text },
  { key: 'state', label: 'Статус', renderer: SbpPaymentStatus },
]

export const MONEY_INFO_LABELS: Array<DataRow<SbpPayment>> = [
  { key: 'amount', label: 'Сумма', renderer: Amount },
  { key: 'commissionMerchant', label: 'Комиссия', renderer: Amount },
  { key: 'toMerchant', label: 'Сумма к зачислению', renderer: Amount },
  { key: 'refundedAmount', label: 'Сумма возвращенных средств', renderer: Amount },
  { key: 'availableForReverse', label: 'Доступно к возврату', renderer: Amount },
]

export const TSP_INFO_LABELS: Array<DataRow<SbpPayment>> = [
  { key: 'reference', label: '№ заказа магазина', renderer: Text },
  { key: 'tspName', label: 'Название ТСП', renderer: Text },
  { key: 'rcvTspAddress', label: 'Адрес ТСП', renderer: Text },
  { key: 'merchantId', label: 'ID ТСП в СБП', renderer: Text },
  { key: 'requestId', label: ' № заявки QR', renderer: Text },
  { key: 'qrcId', label: ' QR-код ID', renderer: Text },
  { key: 'expireQr', label: 'Время экспирации QR', renderer: Date },
  { key: 'trxId', label: ' ID платежа СБП', renderer: Text },
  { key: 'accountNumber', label: 'Номер счёта ЮЛ', renderer: Text },
]

export const SENDER_INFO_C2B_LABELS: Array<DataRow<SbpPayment>> = [
  { key: 'sndPam', label: 'ФИО Клиента', renderer: Text },
  { key: 'sndPhone', label: 'Телефон клиента', renderer: Text },
]

export const SENDER_INFO_B2B_LABELS: Array<DataRow<SbpPayment>> = [
  { key: 'sndLegalEntityName', label: 'Наименование ЮЛ', renderer: Text },
  { key: 'sndInn', label: 'ИНН ЮЛ', renderer: Text },
  { key: 'sndAccountNum', label: 'Счёт ЮЛ', renderer: Text },
  { key: 'sndBic', label: 'БИК банка отправителя', renderer: Text },
  { key: 'sndBankNameRus', label: 'Наименование банка отправителя', renderer: Text },
]

export const REFUND_GENERAL_INFO: Array<DataRow<SbpRefundOperation>> = [
  { key: 'operationId', label: 'Номер операции', renderer: Text },
  { key: 'trxId', label: 'ID возврата СБП', renderer: Text },
  { key: 'type', label: 'Тип операции', renderer: OperationType },
  { key: 'createTime', label: 'Дата и время', renderer: Date },
  { key: 'state', label: 'Статус', renderer: SbpPaymentStatus },
  { key: 'amount', label: 'Сумма', renderer: Amount },
]

export const REFUND_ADDITIONAL_INFO: Array<DataRow<SbpRefundOperation>> = [
  { key: 'paymentPurpose', label: 'Назначение платежа', renderer: Text },
  { key: 'accountNumber', label: 'Номер счёта ЮЛ', renderer: Text },
  { key: 'merchantId', label: 'Код ТСП в СБП', renderer: Text },
  { key: 'tspName', label: 'Название ТСП', renderer: Text },
  { key: 'qrcId', label: 'Идентификатор QR', renderer: Text },
  { key: 'sndPam', label: 'ФИО Клиента', renderer: Text },
  { key: 'sndPhone', label: 'Телефон клиента', renderer: Text },
]
